import React, { useEffect, useState } from "react";
import "./googleTranslate.scss";

declare global {
  interface Window {
    googleTranslateElementInit: () => void;
    google: any;
  }
}

const GoogleTranslate = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("preferredLanguage") || ""
  );

  useEffect(() => {
    const addGoogleTranslateScript = () => {
      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            autoDisplay: false,
          },
          "google_translate_element"
        );
      };
    };

    addGoogleTranslateScript();
  }, []);

  const changeLanguage = (lang: string) => {
    if (selectedLanguage === lang) return;
    setSelectedLanguage(lang);
    const select = document.querySelector(
      "select.goog-te-combo"
    ) as HTMLSelectElement | null;
    if (select) {
      select.value = lang;
      select.dispatchEvent(new Event("change"));
      localStorage.setItem("preferredLanguage", lang);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  return (
    <div className="google-translate-wrapper notranslate" translate="no">
      <div id="google_translate_element" style={{ display: "none" }}></div>

      {/* Desktop Toggle */}
      <button
        className="btn btn-light d-flex align-items-center gap-2 googl-translator-padding"
        onClick={() => changeLanguage(selectedLanguage === "ar" ? "en" : "ar")}
      >
        {/* 🌐 */}
        <span className="text-uppercase fw-bold" style={{minWidth:"50px"}}>
          {selectedLanguage === "ar" ? "🇬🇧 en" : "🇸🇦 ar" }
        </span>
      </button>
    </div>
  );
};

export default GoogleTranslate;
